'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getParticipants = require('../events/getParticipants');

var _getParticipants2 = _interopRequireDefault(_getParticipants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (feis_id, event_id) {
  var fetchParticipants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    dispatch({
      feis_id: feis_id,
      event_id: event_id,
      type: 'SET_CURRENT_ANNOUNCE_EVENT'
    });

    if (event_id && fetchParticipants) {
      return dispatch((0, _getParticipants2.default)(feis_id, event_id));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/announce/setCurrentEvent.js
// module id = 618
// module chunks = 0